import firebase from 'firebase/app'

import * as crud from './crud'


const balanceMapping = (doc, data) => ({
  ...crud.getDefaultMapping(doc, data),
  expires_at: data.expires_at && data.expires_at.toDate(),
})

export const getBalancesByUser = async (userId, options = {}) => {
  const db = firebase.firestore()

  return crud.getAll(db.collection('users').doc(userId).collection('wallets'), {
    ...options,
    map: balanceMapping,
    limit: 1000
  })
}

export const createBalance = async (userId, data, options = {}) => {
  const db = firebase.firestore()

  if (!data.expires_at) {
    data.expires_at = new Date()
    data.expires_at.setFullYear(data.expires_at.getFullYear() + 1)
  }

  return crud.add(db.collection('users').doc(userId).collection('wallets'), data, {
    ...options,
    disableReturn: true,
  })
}
